import request from '@/utils/request'

export function getList(params) {
    return request({
        url: '/api/PmiDept/Load',
        method: 'get',
        params
    })
}

export function add(data) {
    return request({
        url: '/api/PmiDept/Add',
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: '/api/PmiDept/Update',
        method: 'post',
        data
    })
}

export function del(data) {
    return request({
        url: '/api/PmiDept/Delete',
        method: 'post',
        data
    })
}

// 获取树形结构
export function getDeptTree(params) {
    return request({
        url: '/api/PmiDept/DeptTree',
        method: 'get',
        params
    })
}


// 获取地市
export function getCity(params) {
    return request({
        url: '/api/PmiDept/GetCity',
        method: 'get',
        params
    })
}

export function getDeptById(params) {
    return request({
        url: '/api/PmiDept/Get',
        method: 'get',
        params
    })
}

export function getTjUserCount(params) {
    return request({
        url: '/api/PmiApp/TjUserCount',
        method: 'get',
        params
    })
}

export function getTjUserLearn(params) {
    return request({
        url: '/api/PmiApp/TjUserLearn',
        method: 'get',
        params
    })
}